import {
    LoginProvidersApi,
    LoginRequestsApi,
    WelcomeBannerApi,
    ApiClient,
} from '@nutanix-api/iam-js-client';
import { oidc } from '../config';
import * as constants from '../constants';

const apiClient = new ApiClient();
apiClient.allowVersionNegotiation = false;

let loginProvidersApi = new LoginProvidersApi(apiClient);
let loginRequestsApi = new LoginRequestsApi(apiClient);
let welcomeBannerApi = new WelcomeBannerApi(apiClient);

const IamApis = {
    DISCOVER: {
        headers: {},
        method: 'get',
        name: 'discover',
        url: oidc.discoveryUrl,
    },
    GET_PRISM_VERSION: {
        method: 'get',
        name: 'applianceVersion',
        url: '/PrismGateway/services/rest/v1/utils/pre_login_details',
    },
};

export const iamV4Apis = {
    [constants.GET_PROVIDERS_LIST]: {
        relatedClass: loginProvidersApi,
        getFunction: loginProvidersApi.listLoginProviders,
        method: 'get',
    },
    [constants.GET_LOGIN_REQUEST]: {
        relatedClass: loginRequestsApi,
        getFunction: loginRequestsApi.getLoginRequestById,
        method: 'get',
    },
    [constants.GET_WELCOME_BANNER]: {
        relatedClass: welcomeBannerApi,
        getFunction: welcomeBannerApi.getWelcomeBanner,
        method: 'get',
        // This is used to handle the error on the notification trigger
        errorAction: constants.V4_API_GENERAL_FAILED,
        shouldIgnoreError: true,
    },
};

export default IamApis;
